<template>
    <div class="flex flex-col h-screen min-h-screen px-5 bg-black bg-opacity-90 p-10 ">
        <div class="max-w-md place-self-center">
            <img
                class="mx-auto pt-5"
                v-bind:src="$page.props.white_label.data.logo_black"
                width="200"
            />
            <h2 class="font-semibold text-xl text-white text-center mt-5">
                Pagamento Pix
            </h2>
            <div class="mx-5 text-left">
                <span class="text-sm leading-none text-gray-400">
                    Antes de efetuar essa transação confirme as taxas e valores listado abaixo:
                </span>
            </div>
            <div class="border border-gray-400 rounded p-3 mx-10 my-5">
                <div class="grid grid-cols-2 grid-flow-col gap-4">
                    <div class="text-gray-400">Valor da venda</div>
                    <div class="text-white text-right font-semibold">R$ {{data.amount | currency}}</div>
                </div>
                <div class="grid grid-cols-2 grid-flow-col gap-4">
                    <div class="text-gray-400">Valor em taxas</div>
                    <div class="text-white text-right font-semibold">R$ {{data.fees | currency}}</div>
                </div>
            </div>
            <div class="grid grid-cols-2 grid-flow-col gap-4 mt-5 mx-10">
                <div class="text-gray-400">Total a pagar</div>
                <div class="text-white text-lg text-right font-semibold">R$ {{data.total_amount | currency}}</div>
            </div>
        </div>
        <div class="fixed bottom-10 place-self-center">
            <button class="w-52 text-xs md:text-sm font-bold py-3 px-3 md:px-6 rounded-full uppercase bg-yellow-300 hover:bg-yellow-400 object-center"
                    @click="$emit('accepted', true)">
                CONFIRMAR
            </button>
        </div>
    </div>
</template>
<script>

export default {
    props: ['data']
}


</script>
